module.exports = __webpack_public_path__ + "static/media/upgrades.dad4fcac.svg";